import keys from '@debbie/common/dist/cache/keys.js';
import { DKTribunalJobType } from '@debbie/common/dist/tribunal/jobs/countries/denmark.js';
import * as files from '@debbie/cortex/dist/api/files.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import React, { useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useSelector } from 'react-redux';
import Button from '../../../Button.js';
import File from '../../../File/index.js';
import Input from '../../../Input.js';
const ClosedObjection = (props) => {
    const lang = useSelector((s) => s.lang);
    const [loading, setLoading] = useState(false);
    const [fsNo, setFsNo] = useState(props.tribunalCase.reference || 'FS');
    const [file, setFile] = useState(null);
    const dropzoneRef = useRef(null);
    const promiseFileReader = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (event) => {
                resolve(event.target.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    const uploadFile = async (acceptedFiles) => {
        for (let i = 0; i < acceptedFiles.length; i++) {
            const acceptedFile = acceptedFiles[i];
            const content = await promiseFileReader(acceptedFile);
            const { file } = await files.save({
                content: content.split('base64,')[1],
                name: acceptedFile.name,
                contentType: acceptedFile.type,
            });
            setFile(file);
        }
    };
    const closeObjection = async () => {
        setLoading(true);
        try {
            await tribunalAPI.createTribunalJob({
                type: DKTribunalJobType.ClosedObjection,
                tribunalCaseId: props.tribunalCase.id,
                data: {
                    fileId: file?.fileId,
                },
                caseId: props.tribunalCase.caseId,
                reference: fsNo.trim(),
            });
            props.onSubmit();
        }
        catch (err) {
            console.error(err);
        }
        setLoading(false);
        q.invalidate(keys.write.create(tribunalJobsEntity));
    };
    return (React.createElement(Dropzone, { style: {}, disableClick: true, ref: dropzoneRef, multiple: true, onDrop: uploadFile },
        React.createElement("h4", null, lang.tribunal.closedObjection),
        !props.tribunalCase.reference && (React.createElement(Input, { placeholder: 'FS-nummer', value: fsNo, onChange: (e) => setFsNo(e.target.value) })),
        React.createElement(Button, { onClick: () => {
                // @ts-ignore
                dropzoneRef.current?.open();
            }, size: "small", theme: "secondary", block: true }, lang.tribunal.addDocument),
        file && (React.createElement("p", null,
            React.createElement(File, { file: file, removable: true, onRemove: () => setFile(null) }))),
        React.createElement("br", null),
        React.createElement(Button, { onClick: closeObjection, loading: loading, block: true }, lang.tribunal.closedObjection)));
};
export default ClosedObjection;
//# sourceMappingURL=ClosedObjection.js.map